export default __webpack_public_path__ + "static/media/graf-location.d8dec73f.svg";